import {
	Directive,
	ElementRef,
	HostListener,
	inject,
	Input,
	OnDestroy,
	OnInit
} from '@angular/core';
import { FormControl, NgControl, ValidationErrors } from '@angular/forms';
import { uniqueId } from 'lodash';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../core';


/**
 * Directive to show validation messages for form controls.
 */
@Directive({
	selector: '[appFormValidationMsg]'
})
export class FormValidationMsgDirective implements OnInit, OnDestroy {

	private readonly elRef = inject(ElementRef);
	private readonly control = inject(NgControl);
	private readonly langSrv = inject(LanguageService);

	@Input('appFormValidationMsg') validationMsgs: { [key: string]: string[] } | null = null;
	@Input() container: HTMLElement | null = null;
	@Input() customControl: FormControl | null = null;

	@Input() blurFlag: boolean = false;
	errorElemId: string = '';
	statusChangeSubscription?: Subscription;

	private get _control(): FormControl | null {
		return this.customControl ?? this.control?.control as FormControl | null;
	}

	ngOnInit(): void {
		this.errorElemId = String(this.control?.name) + "-" + uniqueId() + '-error-msg';
		if (!this.blurFlag) {
			this.formControlStatusChange();
		}
	}

	formControlStatusChange(): void {
		this.statusChangeSubscription = this._control?.statusChanges?.subscribe(
			(status) => { status == 'INVALID' ? this.showError() : this.removeError(); }
		)
	}

	@HostListener('blur', ["$event"])
	handleBlurEvent(event: any) {
		if (!this._control) return;
		if (this._control.value == null || this._control.value == '') {
			this._control.errors ? this.showError() : this.removeError();
		}
		if (this.blurFlag) {
			this.formControlStatusChange();
			this._control?.markAsTouched({ onlySelf: false })
			this._control.updateValueAndValidity({ onlySelf: false, emitEvent: true })
			this.blurFlag = false;
		}
	}

	public showError(): void {
		this.removeError();
		const valErrors = this._control?.errors;
		if (valErrors) {
			const errorMsg = this.getMessageErr(Object.entries(valErrors)[0]);
			const errorDiv = '<div class="invalid-feedback" id="' + this.errorElemId + '">' + errorMsg + '</div>';
			const closestControlName = this.container || this.elRef.nativeElement.closest('[formControlName]');
			if (closestControlName) {
				closestControlName.insertAdjacentHTML('afterend', errorDiv);
			}
		}
	}

	public removeError(): void {
		const errorElement = document.getElementById(this.errorElemId);
		if (errorElement) errorElement.remove();
	}

	public getMessageErr(validationError: ValidationErrors): string {
		let res = '';
		const errMsg = this.validationMsgs?.[validationError[0]];
		if (errMsg?.length) {
			res = this.langSrv.labels()[errMsg[0]];
			for (let index = 1; index < errMsg.length; index++) {
				res = res?.replace(`{{${index}}}`, errMsg[index]);
			}
		}
		return res;
	}


	ngOnDestroy(): void {
		this.statusChangeSubscription?.unsubscribe();
	}
}